// src/components/admin/page-management/section-forms/SpacerForm.js
import React from 'react';

const SpacerForm = ({ content, updateContent }) => {
  return (
    <div>
      <h3 className="font-bold text-lg mb-4">Spacer Section</h3>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Desktop Height</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="2rem or 50px"
          value={content?.spacerHeight || '2rem'}
          onChange={(e) => updateContent('spacerHeight', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Enter a value like "2rem" or "50px" to control the spacing height on desktop.
        </p>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Tablet Height</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="1.5rem or 30px"
          value={content?.tabletSpacerHeight || ''}
          onChange={(e) => updateContent('tabletSpacerHeight', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Optional: Enter a different height for tablet devices. Defaults to desktop height if left empty.
        </p>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Mobile Height</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="1rem or 20px"
          value={content?.mobileSpacerHeight || ''}
          onChange={(e) => updateContent('mobileSpacerHeight', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Optional: Enter a different height for mobile devices. Defaults to desktop height if left empty.
        </p>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Visibility</label>
        <div className="flex flex-col space-y-2">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox mr-2"
              checked={!content?.hideOnDesktop}
              onChange={(e) => updateContent('hideOnDesktop', !e.target.checked)}
            />
            <span className="text-sm">Show on desktop</span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox mr-2"
              checked={!content?.hideOnTablet}
              onChange={(e) => updateContent('hideOnTablet', !e.target.checked)}
            />
            <span className="text-sm">Show on tablet</span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox mr-2"
              checked={!content?.hideOnMobile}
              onChange={(e) => updateContent('hideOnMobile', !e.target.checked)}
            />
            <span className="text-sm">Show on mobile</span>
          </label>
        </div>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Custom Classes</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="my-custom-spacer-class"
          value={content?.customClasses || ''}
          onChange={(e) => updateContent('customClasses', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Optional: Add custom CSS classes to the spacer.
        </p>
      </div>
      
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">ID</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="my-spacer-id"
          value={content?.id || ''}
          onChange={(e) => updateContent('id', e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">
          Optional: Add an HTML ID to the spacer for linking or scripting.
        </p>
      </div>
    </div>
  );
};

export default SpacerForm;





// // src/components/admin/page-management/section-forms/SpacerForm.js
// import React from 'react';

// const SpacerForm = ({ content, updateContent }) => {
//   return (
//     <div>
//       <h3 className="font-bold text-lg mb-4">Spacer Section</h3>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Height</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           placeholder="2rem or 50px"
//           value={content?.spacerHeight || '2rem'}
//           onChange={(e) => updateContent('spacerHeight', e.target.value)}
//         />
//         <p className="text-xs text-gray-500 mt-1">
//           Enter a value like "2rem" or "50px" to control the spacing height.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default SpacerForm;



